(function () {
  if (window.sanoMarinusConversionLoaded) {
    return;
  }

  window.sanoMarinusConversionLoaded = true;

  var MARINUS_HANDLE = '/products/marinus-sea-superfood-em-capsulas';
  var VARIANT_1 = '50398345462058';
  var VARIANT_3 = '50398345494826';

  function isMarinusPage() {
    return window.location.pathname.indexOf(MARINUS_HANDLE) !== -1 || !!document.querySelector('.sano-kit-selector [data-variant-id="' + VARIANT_3 + '"], .sano-kit-option[data-variant-id="' + VARIANT_3 + '"]');
  }

  function isCartPage() {
    return window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart') === 0;
  }

  function getVariantField() {
    return document.querySelector('form[action*="/cart/add"] [name="id"], select[name="id"], input[name="id"]');
  }

  function selectedVariantId() {
    var field = getVariantField();
    return field ? String(field.value) : VARIANT_1;
  }

  function selectKit(card, variantId) {
    if (!variantId) {
      return;
    }

    var selector = card && card.closest ? card.closest('.sano-kit-selector') : document.querySelector('.sano-kit-selector');
    if (selector) {
      selector.querySelectorAll('[data-variant-id]').forEach(function (option) {
        option.classList.remove('is-active');
        option.classList.remove('active');
        option.setAttribute('aria-selected', 'false');
      });
    }

    if (card) {
      card.classList.add('is-active');
      card.classList.add('active');
      card.setAttribute('aria-selected', 'true');
    }

    document.querySelectorAll('form[action*="/cart/add"] [name="id"], select[name="id"], input[name="id"]').forEach(function (field) {
      field.value = variantId;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });

    updateStickyCta();
  }

  function underlyingAction(event) {
    if (!document.elementsFromPoint) {
      return null;
    }

    var elements = document.elementsFromPoint(event.clientX, event.clientY);
    for (var i = 0; i < elements.length; i += 1) {
      var element = elements[i];
      if (!element || element === event.target || !element.closest) {
        continue;
      }

      var card = element.closest('.sano-kit-selector [data-variant-id], .sano-kit-option[data-variant-id]');
      if (card) {
        return card;
      }

      var action = element.closest('form[action*="/cart/add"] button, form[action*="/cart/add"] input[type="submit"], a[href]');
      if (action) {
        return action;
      }
    }

    return null;
  }

  function moveKitBeforeBuyBox() {
    if (!isMarinusPage()) {
      return;
    }

    var kit = document.querySelector('.sano-kit-selector');
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!kit || !form || kit.dataset.sanoMoved === 'true') {
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'sano-marinus-plan-priority';
    wrapper.appendChild(kit);
    form.parentNode.insertBefore(wrapper, form);
    kit.dataset.sanoMoved = 'true';
  }

  function cleanMarinusCopy() {
    if (!isMarinusPage()) {
      return;
    }

    document.body.classList.add('sano-marinus-page-v15');

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach(function (node) {
      var value = node.nodeValue || '';
      if (value.trim() === 'filler') {
        node.nodeValue = '';
        return;
      }
      if (value.indexOf('Envio grátis acima de 49€') !== -1) {
        node.nodeValue = value.replace(/Envio grátis acima de 49€(?: \(Portugal Continental\))?/g, 'Envio grátis disponível para Portugal');
      }
    });
  }

  function createStickyCta() {
    if (!isMarinusPage() || document.querySelector('.sano-marinus-sticky')) {
      return;
    }

    var sticky = document.createElement('div');
    sticky.className = 'sano-marinus-sticky';
    sticky.innerHTML = '<div class="sano-marinus-sticky__text"><strong>MARINUS</strong><span data-sano-sticky-price>1 frasco - 24,90 €</span></div><button type="button" class="sano-marinus-sticky__button">Comprar agora</button>';
    document.body.appendChild(sticky);

    sticky.querySelector('button').addEventListener('click', function () {
      var addButton = document.querySelector('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] input[type="submit"]');
      if (addButton) {
        addButton.click();
      }
    });

    updateStickyCta();
  }

  function updateStickyCta() {
    var price = document.querySelector('[data-sano-sticky-price]');
    if (!price) {
      return;
    }
    if (selectedVariantId() === VARIANT_3) {
      price.textContent = 'Pack 3 - 64,90 €';
    } else {
      price.textContent = '1 frasco - 24,90 €';
    }
  }

  function defaultPortugalInCartEstimator() {
    if (!isCartPage()) {
      return;
    }

    document.querySelectorAll('select').forEach(function (select) {
      var portugalOption = Array.prototype.slice.call(select.options || []).find(function (option) {
        return /Portugal/i.test(option.text) || option.value === 'Portugal' || option.value === 'PT';
      });
      if (portugalOption && (/country/i.test(select.name || '') || /country/i.test(select.id || '') || select.value === 'United States' || select.value === 'US' || /Estados Unidos/i.test(select.options[select.selectedIndex] && select.options[select.selectedIndex].text || ''))) {
        select.value = portugalOption.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function boot() {
    cleanMarinusCopy();
    moveKitBeforeBuyBox();
    createStickyCta();
    defaultPortugalInCartEstimator();
  }

  window.sanoSelectKit = function (element, variantId) {
    var card = element && element.closest ? element.closest('[data-variant-id]') : null;
    selectKit(card, variantId);
  };

  document.addEventListener('click', function (event) {
    if (!isMarinusPage()) {
      return;
    }

    var card = event.target && event.target.closest ? event.target.closest('.sano-kit-selector [data-variant-id], .sano-kit-option[data-variant-id]') : null;
    var forwardedTarget = null;

    if (!card && String(event.target && event.target.className).indexOf('kl-private-reset') !== -1) {
      forwardedTarget = underlyingAction(event);
      if (forwardedTarget && forwardedTarget.matches && forwardedTarget.matches('.sano-kit-selector [data-variant-id], .sano-kit-option[data-variant-id]')) {
        card = forwardedTarget;
      }
    }

    if (card) {
      var variantId = card.getAttribute('data-variant-id');
      if (variantId) {
        event.preventDefault();
        event.stopPropagation();
        selectKit(card, variantId);
      }
      return;
    }

    if (forwardedTarget && forwardedTarget.click) {
      event.preventDefault();
      event.stopPropagation();
      forwardedTarget.click();
    }
  }, true);

  document.addEventListener('change', updateStickyCta, true);
  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  setTimeout(boot, 750);
  setTimeout(boot, 2000);
}());
